import Page from './Page';

var DynamicQueryDomain = (function () {
    let domainValue = {};

    return {
        items: domainValue,
        aggregations: function () { return domainValue["aggregations"]; },
        formats: function () { return domainValue["formats"]; },
        cubeLayouts: function () { return domainValue["cube_layouts"] }
    };
})();

var DynamicQueryApi = (function () {

    let initPromise;

    var internalInitPromise = function () {
        if (!initPromise) {
            initPromise = $.ajax({
                type: 'GET',
                contentType: 'application/json',
                dataType: 'json',
                url: Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/domain',
                cache: false,
                async: true
            }).then(data => {
                let domainValue = data.content.items.reduce(function (p, c) { p[c.name] = c.items; return p; }, {});
                $.extend(DynamicQueryDomain.items, domainValue);
                return data;
            });
        }
        return initPromise;
    };

    var internalGet = function (url) {
        return internalInitPromise().then(() => {
            return $.ajax({
                type: 'GET',
                contentType: 'application/json',
                dataType: 'json',
                url: url,
                cache: false,
                async: true
            });
        });
    };

    var internalPost = function (url, data) {
        return internalInitPromise().then(() => {
            return $.ajax({
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                url: url,
                data: JSON.stringify(data),
                cache: false,
                async: true
            });
        });
    };


    var internalGetDesign = function (dynamicQueryId) {
        return internalGet(Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/design/' + dynamicQueryId);
    };

    var internalPostDesign = function (dynamicQueryId, data) {
        return internalPost(Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/design/' + dynamicQueryId, data);
    };

    var internalGetAvailableFields = function (dynamicQueryId, data) {
        return internalPost(Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/design/' + dynamicQueryId + '/availableitems', data);
    };

    return {
        getDesignPromise: internalGetDesign,
        postDesignPromise: internalPostDesign,
        getAvailableFieldsPromise: internalGetAvailableFields
    };

})();

var DynamicQueryIds = {
    GridFieldsSelector: "#CustomColumnsGrid",
    GridFiltersSelector: "#CustomFiltersGrid",
    ErrorPlaceholderSelector: "#ErrorPlaceholder"
};

var DynamicQueryFieldPicker = (function () {

    var _fieldType;
    var id_counter = 1;

    var logError = function (jqXHR) {
        console.error('Response:', jqXHR.responseText);
        $(".dynamic-query-explorer").empty().append('<div class="alert alert-danger">Ocorreu um erro ao carregar os campos. Atualize a página e tente novamente.</div>');
    };

    var filterSearchFields = function (force) {
        var texto = $(".dynamic-query-search").val();

        // Não quer forçar e não tem filtro
        if (!force && texto.length == 0) {
            return;
        }

        var items = $("li.col-item-selectable");

        if (texto.length === 0) {
            $(items).removeClass('hidden');
            return;
        }

        var hashVisiveis = {};

        var exp = new RegExp(texto, 'i');
        $(items).each(function (index, item) {
            var title = $(item).data("title");
            if (exp.test(title)) {
                hashVisiveis[$(item).attr("id")] = true;

                // Deixar parents visiveis
                $(item).parentsUntil(".dynamic-query-explorer", "li.col-item-selectable").each(function (index2, item2) {
                    hashVisiveis[$(item2).attr("id")] = true;
                });
            };
        });

        $(items).each(function (index, item) {
            var li_id = $(item).attr("id");
            $(item).toggleClass('hidden', !hashVisiveis[li_id]);
        });
    };

    var addExplorerFields = function (parent, titlePrefix, columns, ulClass, emptyMessage) {

        var html = emptyMessage;
        if (columns.length != 0) {
            var html = '<ul class="list-unstyled ' + ulClass + '">';
            columns.forEach(function (item) {
                let li_id = 'fieldpicker_item_' + (id_counter++);
                html += '<li id="' + li_id + '" class="col-item-selectable" data-expression="' + item.expression + '" data-aggregation="' + item.aggregation + '" data-filter-type="' + item.filterType + '" data-title="' + item.title + '" data-display-format="' + item.format + '" data-expandable-argument="' + item.expandableArgument + '">';
                html += '<label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ';
                html += ' onclick="parent.Benner.DynamicQuery.FieldPicker.toggleSelection(this);"><span></span>' + item.selectionTitle;

                if (item.expandableArgument) {
                    html += '<a title="Navegar" data-expandable-argument="' + item.expandableArgument + '" class="btn btn-xs btn-circle" onclick="Benner.DynamicQuery.FieldPicker.expand(this);return false;" ><i aria-hidden="true" class="fa-duotone fa-plus fa-fw"></i></a>';
                };

                html += '</label></li>';
            });
            html += '</ul>';
        }

        if (html) {
            $(parent).append(html);
        }
    }

    var internalToggleSelection = function (anyElement) {
        var element = $(anyElement).closest("li");
        var target = {
            expression: $(element).data("expression"),
            title: $(element).data("title"),
            aggregation: $(element).data("aggregation"),
            format: $(element).data("display-format"),
            filterType: $(element).data("filter-type")
        };

        var wasSelected = false;
        DynamicQueryFieldPicker.selection = DynamicQueryFieldPicker.selection.filter(function (item) {
            wasSelected = item.expression == target.expression;
            return item.expression != target.expression;
        });
        if (!wasSelected) {
            DynamicQueryFieldPicker.selection.push(target);
        }
    };

    var internalExpand = function (element) {

        var a = $(element).closest("a");
        $(a).find("i").toggleClass("fa-plus fa-minus");

        var li = $(element).closest("li");
        if ($(li).is(".loaded")) {

            // reexibir se foi filtrado
            if ($(li).hasClass("hidden")) {
                $(li).find("li").removeClass("hidden");
            };

            $(li).find("ul").toggle("collapse");
            return;
        }

        var queryId = $(element).closest(".dynamic-query-explorer").data("queryid");
        var argument = $(a).data("expandable-argument");
        var req = {
            fieldType: _fieldType,
            expandableArgument: argument
        };

        DynamicQueryApi
            .getAvailableFieldsPromise(queryId, req)
            .done(data => {
                var parentLi = $(element).closest('li');
                $(parentLi).addClass("loaded");

                //var path = $(parentLi).data("path") + '>' + tableName + '.';
                var title = $(parentLi).data("title") + ' - ';

                addExplorerFields(li, title, data.content.fields, "collapse");
                $(parentLi).find("ul").toggle("collapse");
                return data;
            })
            .catch(jqXHR => {
                logError(jqXHR);
            });
    };

    var internalShow = function (dynamicQueryId, fieldType, closeCallback) {

        _fieldType = fieldType;

        var onOpen = function () {
            DynamicQueryFieldPicker.selection = [];

            $(".dynamic-query-search").on("input", function () {
                filterSearchFields(true);
            });

            $(".dynamic-query-explorer").each(function (index, item) {
                var queryId = $(item).data("queryid");

                var req = {
                    fieldType: _fieldType,
                    expandableArgument: ""
                };

                DynamicQueryApi
                    .getAvailableFieldsPromise(queryId, req)
                    .done(function (data) {
                        $(item).empty();
                        addExplorerFields(item, "", data.content.fields, "", "Nenhum campo disponível");
                    })
                    .catch(jqXHR => {
                        logError(jqXHR);
                    });
            });

            var ele = $(".dynamic-query-search").get(0);
            if (ele) {
                ele.focus();
            }

        };

        var onClose = function () {

            if (DynamicQueryFieldPicker.selection.length == 0) {
                return;
            };

            closeCallback(DynamicQueryFieldPicker.selection);
        };

        // garantir que não ficou nenhum lixo
        $(".select-field-modal").remove();

        var html = '<div class="select-field-modal"><div class="filter-search-form note note-info note-bordered" style="margin-bottom: 10px">'
            + '<div class="input-group filter-simple-search col-lg-12 col-md-12 col-sm-12 col-xs-12">'
            + '<input class="dynamic-query-search form-control" /></div></div >'
            + '<div class="dynamic-query-explorer" data-queryid="' + dynamicQueryId + '">Carregando...</div></div>';

        Benner.ModalPage.show({ customBody: html, size: "large", title: "Selecione os itens desejados", height: 500 }, onOpen, onClose);
    };

    var internalCreateNameProvider = function (selector) {
        var existingNames = {};

        $(selector).find("input[name=NOME]").each(function (index, item) {
            var colName = $(item).val();
            existingNames[colName] = true;
        });

        return {
            getNewName: function (expression) {
                var parts1 = expression.split('>');
                var name = parts1.pop().replace('.', '_');
                var root = name;
                var count = 1;
                while (existingNames[name]) {
                    name = root + count;
                    count++;
                }
                existingNames[name] = true;
                return name;
            }
        };
    }

    return {
        show: internalShow,
        selection: [],

        toggleSelection: internalToggleSelection,
        expand: internalExpand,

        createNameProvider: internalCreateNameProvider
    };

})();

var DynamicQueryFields = (function () {

    var id_counter = 1;
    const baseStruct = {
        id: "",
        columnType: "",
        title: "",
        aggregation: "",
        summary: "",
        format: "",
        hasBreak: false,
        cubeLayout: "",
        expression: ""
    };

    var internalCreate = function () {
        return $.extend({}, baseStruct);
    };

    var makeSelectTd = function (fieldName, selected, options) {
        var html = '<td><select class="form-control custom-field" name="' + fieldName + '">';

        options.forEach(function (option) {
            html += '<option value="' + option.value + '" ' + (selected == option.value ? 'selected' : '') + '>' + option.title + '</option>';
        });
        html += '</select></td>';
        return html;
    };

    var internalToTableRow = function (col) {
        id_counter++;

        var expressionAttrs = col.columnType == 'expression' ? '' : 'readonly="readonly" disabled="disabled"';
        var html = "";
        html += '<tr data-columntype="' + col.columnType + '" ">';
        html += '<td><div draggable="true" ondragstart="Benner.DynamicQuery.DragDrop.dragRowStart(event)" ondragover="Benner.DynamicQuery.DragDrop.dragRowOver(event)" ondrop="Benner.DynamicQuery.DragDrop.dragRowDrop(event)"><i class="fa fa-up-down"></i></div></td>';
        html += '<td><input type="text" class="form-control custom-field" name="NOME" value="' + col.id + '" title="' + col.expression + '" /></td>';
        html += '<td><input type="text" class="form-control custom-field" name="LEGENDA" value="' + col.title + '" /></td>';

        var inputHtml = '<input type="text" id="fieldexpression_' + id_counter + '" class="form-control custom-field" name="EXPRESSAO" value="' + col.expression + '" ' + expressionAttrs + ' />';
        html += '<td>';
        if (col.columnType == 'expression') {
            html += '<div class="input-group">'
            html += inputHtml;
            html += '<span class="input-group-btn">';
            html += '<button class="btn btn-default" type="button" onclick="javascript:Benner.TextEditor.show(' + "'../../TextEditor.aspx', 'fieldexpression_" + id_counter + "');" + ' ">';
            html += '<i class="fa fa-pencil" ></i></button></span></div>';
        } else {
            html += inputHtml;
        }
        html += '</td>';

        html += makeSelectTd("FUNCAO", col.aggregation, DynamicQueryDomain.aggregations());
        html += makeSelectTd("SUMARIO", col.summary, DynamicQueryDomain.aggregations());
        html += makeSelectTd("FORMATO", col.format, DynamicQueryDomain.formats());
        html += makeSelectTd("CUBO", col.cubeLayout, DynamicQueryDomain.cubeLayouts());
        html += '<td><label class="boolean-control mt-checkbox mt-checkbox-outline"><input type="checkbox" class="custom-field break-checkbox-field" name="TEMQUEBRA" ' + (col.hasBreak == true ? 'checked="checked"' : '') + '"><span></span></label></td>';
        html += '<td><a title="Excluir coluna" class="btn btn-xs btn-circle red" onclick="Benner.DynamicQuery.removeItem(this);return false;"><i aria-hidden="true" class="fa-duotone fa-trash-can fa-fw"></i></a></td>';
        html += '</tr>';
        return html;
    };

    var internalReadRow = function (tr) {

        var obj = {
            columnType: $(tr).data("columntype"),
            id: $(tr).find("input[name=NOME]").val(),
            title: $(tr).find("input[name=LEGENDA]").val(),
            expression: $(tr).find("input[name=EXPRESSAO]").val(),
            aggregation: $(tr).find("[name=FUNCAO]").val(),
            summary: $(tr).find("[name=SUMARIO]").val(),
            format: $(tr).find("[name=FORMATO]").val(),
            cubeLayout: $(tr).find("[name=CUBO]").val(),
            hasBreak: $(tr).find("input[name=TEMQUEBRA]").prop("checked")
        }

        return obj;
    };

    return {
        create: internalCreate,
        readRow: internalReadRow,
        toTableRow: internalToTableRow,
    };

})();

var DynamicQueryFilters = (function () {

    const baseStruct = {
        id: "",
        filterType: "",
        title: "",
        isRequired: false,
        expression: "",
        resultFields: "",
        multiSelection: false,
        localWhere: "",
        isPredefined: false
    };

    var internalCreate = function () {
        return $.extend({}, baseStruct);
    };

    var getAllowCheckMultiple = function (filterType) {
        return filterType.startsWith('lookup') || filterType.startsWith('date');
    };

    var internalToTableRow = function (filter) {
        var attrs = filter.isPredefined ? ' readonly="readonly" disabled="disabled"' : '';
        var lookupAttrs = filter.filterType.startsWith('lookup') ? '' : ' readonly="readonly" disabled="disabled"';
        var multipleAttrs = getAllowCheckMultiple(filter.filterType) ? '' : ' readonly="readonly" disabled="disabled"';

        var html = "";
        html += '<tr data-filtertype="' + filter.filterType + '" data-expression="' + filter.expression + '" data-ispredefined="' + filter.isPredefined + '">';
        html += '<td><div draggable="true" ondragstart="Benner.DynamicQuery.DragDrop.dragRowStart(event)" ondragover="Benner.DynamicQuery.DragDrop.dragRowOver(event)" ondrop="Benner.DynamicQuery.DragDrop.dragRowDrop(event)"><i class="fa fa-up-down"></i></div></td>';
        html += '<td><input type="text" class="form-control custom-field" name="NOME" value="' + filter.id + '" title="' + filter.expression + '"' + attrs + ' /></td>';
        html += '<td><input type="text" class="form-control custom-field" name="LEGENDA" value="' + filter.title + '" /></td>';
        html += '<td><label class="boolean-control mt-checkbox mt-checkbox-outline"><input type="checkbox" class="custom-field break-checkbox-field" name="REQUERIDO" ' + (filter.isRequired == true ? 'checked="checked"' : '') + '"><span></span></label></td>';
        html += '<td><label class="boolean-control mt-checkbox mt-checkbox-outline"><input type="checkbox" class="custom-field break-checkbox-field" name="MULTIPLASELECAO" ' + (filter.multiSelection == true ? 'checked="checked"' : '') + '"' + attrs + multipleAttrs + '><span></span></label></td>';
        html += '<td><input type="text" class="form-control custom-field" name="CAMPOSEXIBICAO" value="' + filter.resultFields + '"' + attrs + lookupAttrs + ' /></td>';
        html += '<td><input type="text" class="form-control custom-field" name="SQLESPECIAL" value="' + filter.localWhere + '"' + attrs + lookupAttrs + ' /></td>';
        html += '<td><a title="Excluir coluna" class="btn btn-xs btn-circle red" onclick="Benner.DynamicQuery.removeItem(this);return false;"><i aria-hidden="true" class="fa-duotone fa-trash-can fa-fw"></i></a></td>';
        html += '</tr>';
        return html;
    };

    var internalReadRow = function (tr) {

        var obj = {
            filterType: $(tr).data("filtertype"),
            expression: $(tr).data("expression"),
            id: $(tr).find("input[name=NOME]").val(),
            title: $(tr).find("input[name=LEGENDA]").val(),
            isRequired: $(tr).find("input[name=REQUERIDO]").prop("checked"),
            resultFields: $(tr).find("input[name=CAMPOSEXIBICAO]").val(),
            multiSelection: $(tr).find("input[name=MULTIPLASELECAO]").prop("checked"),
            localWhere: $(tr).find("input[name=SQLESPECIAL]").val(),
            isPredefined: $(tr).data("ispredefined")
        };

        return obj;
    };

    return {
        create: internalCreate,
        readRow: internalReadRow,
        toTableRow: internalToTableRow,
    };

})();

var DynamicQueryDragDrop = (function () {
    var movingRow;
    var movingGrid;

    var dragRowStart = function (e) {
        movingRow = e.target;
        movingGrid = $(movingRow).closest("table").get(0);
        e.dataTransfer.effectAllowed = 'move';
    };

    var dragRowOver = function (e) {
        // Movendo para própria linha
        if ($(e.target).closest("div").get(0) === movingRow)
            return;

        // Movendo para outro grid
        if ($(e.target).closest("table").get(0) !== movingGrid) {
            return;
        }

        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    var dragRowDrop = function (e) {

        e.preventDefault();

        var toRow = $(e.target).closest("tr").get(0);
        if (toRow.length === 0)
            return;

        var fromRow = $(movingRow).closest("tr").get(0);

        var children = $(fromRow).parent().find("tr").toArray();
        if (children.indexOf(toRow) > children.indexOf(fromRow))
            $(fromRow).insertAfter(toRow);
        else
            $(fromRow).insertBefore(toRow);
    };

    return {
        dragRowStart: dragRowStart,
        dragRowOver: dragRowOver,
        dragRowDrop: dragRowDrop,
    };


})();

var DynamicQuery = (function () {

    var blockUI = function () {
        App.blockUI({ target: $(".dynamic-query-area"), animate: true });
    };

    var unblockUI = function () {
        App.unblockUI($(".dynamic-query-area"));
    };

    var getCurrentId = function () {
        const designPageId = $("#DynamicQueryId").val();
        if (designPageId) {
            return designPageId;
        }

        if (Page.widgets.length > 0) {
            const idByWidget = Page.widgets[0].fields()["codigo"];
            if (idByWidget) {
                return idByWidget;
            }
        }

        throw new Error("Não foi possível definir o identificador da query.");
    };

    var internalUpdateGrid = function (selector, toHtmlFunc, data) {
        var html = data.reduce(function (p, c, i) { return p + toHtmlFunc(c); }, "");
        $(selector + ' > tbody').html(html);
    };

    var internalUpdateGrids = function (content) {
        internalUpdateGrid(DynamicQueryIds.GridFieldsSelector, DynamicQueryFields.toTableRow, content.columns);
        internalUpdateGrid(DynamicQueryIds.GridFiltersSelector, DynamicQueryFilters.toTableRow, content.filters);
    };

    var internalInit = function () {
        var id = getCurrentId();

        setErrorMessage(null);

        blockUI();

        DynamicQueryApi.getDesignPromise(id)
            .done(function (data) {
                var content = data.content;
                $("#DynamicQueryName").text(content.title);
                if (!content.allowDynamicFields) {
                    $("#BtnAddDynamicField").hide();
                }
                if (!content.allowExpressionFields) {
                    $("#BtnAddExpressionField").hide();
                }
                internalUpdateGrids(content);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR.responseJSON.ExceptionMessage);
            }).always(function () {
                unblockUI();
            });
    };

    var internalAddExpressionField = function () {
        let newField = DynamicQueryFields.create();
        newField.columnType = 'expression';
        let html = DynamicQueryFields.toTableRow(newField);

        $(DynamicQueryIds.GridFieldsSelector + ' > tbody').append(html);

        var ele = $(DynamicQueryIds.GridFieldsSelector + ' > tbody > tr:last input:first').get(0);
        if (ele) {
            ele.focus();
        }
    };

    var internalReadItems = function (selector, reader) {
        var items = [];
        let $rows = $(selector + ' > tbody > tr');
        $.each($rows, function () {
            items.push(reader(this));
        });
        return items;
    };

    var setErrorMessage = function (message) {
        let target = $(DynamicQueryIds.ErrorPlaceholderSelector);
        if (message) {
            var formatedMessage = message.replace(/(\r\n|\n|\r)/gm, '<br/>');
            target.html('<div class="alert alert-danger">' + formatedMessage + '</div>');
        } else {
            target.empty();
        }
    };

    var internalSave = function () {

        var fields = internalReadItems(DynamicQueryIds.GridFieldsSelector, DynamicQueryFields.readRow);
        var filters = internalReadItems(DynamicQueryIds.GridFiltersSelector, DynamicQueryFilters.readRow);

        var id = getCurrentId();
        var data = {
            columns: fields,
            filters: filters
        };

        blockUI();
        setErrorMessage(null);

        DynamicQueryApi.postDesignPromise(id, data)
            .done(function (data) {
                internalUpdateGrids(data.content);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseJSON && jqXHR.responseJSON.Message) {
                    setErrorMessage(jqXHR.responseJSON.Message);
                } else {
                    console.log(textStatus, errorThrown);
                    setErrorMessage("Ocorreu um erro ao salvar. Verifique o console para mais detalhes.");
                }
            }).always(function () {
                unblockUI();
            });
    };

    var internalRemoveItem = function (anyElement) {
        $(anyElement).closest('tr').fadeOut(200, function () { $(this).remove(); });
    };

    var internalAddField = function (fieldType) {

        DynamicQueryFieldPicker.show(getCurrentId(), fieldType, function (selection) {

            var nameProvider = DynamicQueryFieldPicker.createNameProvider(DynamicQueryIds.GridFieldsSelector);

            var html = '';
            selection.forEach(function (item) {
                var newField = DynamicQueryFields.create();
                newField.columnType = fieldType;
                $.extend(newField, item);
                newField.id = nameProvider.getNewName(newField.expression);
                html += DynamicQueryFields.toTableRow(newField);
            });

            $(DynamicQueryIds.GridFieldsSelector + ' > tbody').append(html);
        });
    };

    var internalAddFilter = function (fieldType, isPredefined) {

        DynamicQueryFieldPicker.show(getCurrentId(), fieldType, function (selection) {

            var nameProvider = DynamicQueryFieldPicker.createNameProvider(DynamicQueryIds.GridFiltersSelector);

            var html = '';
            selection.forEach(function (item) {
                var newFilter = DynamicQueryFilters.create();
                newFilter.filterType = item.filterType;
                $.extend(newFilter, item);
                newFilter.id = nameProvider.getNewName(newFilter.expression);
                newFilter.isPredefined = isPredefined;
                html += DynamicQueryFilters.toTableRow(newFilter);
            });

            $(DynamicQueryIds.GridFiltersSelector + ' > tbody').append(html);
        });
    };

    var internalAddDynamicField = function () {
        internalAddField('dynamic');
    };

    var internalAddPredefinedField = function () {
        internalAddField('predefined');
    };

    var internalAddPredefinedFilter = function () {
        internalAddFilter('filters', true);
    };

    var internalAddDynamicFilter = function () {
        internalAddFilter('dynamic', false);
    };

    var internalNavigateToGenerate = function () {
        var target = window.location.href.replace("Design.aspx", "Generate.aspx");
        window.location.href = target;
    };

    return {
        init: internalInit,

        addDynamicField: internalAddDynamicField,
        addPredefinedField: internalAddPredefinedField,
        addExpressionField: internalAddExpressionField,

        addDynamicFilter: internalAddDynamicFilter,
        addPredefinedFilter: internalAddPredefinedFilter,

        removeItem: internalRemoveItem,
        save: internalSave,
        navigateToGenerate: internalNavigateToGenerate,

        DragDrop: DynamicQueryDragDrop,
        FieldPicker: DynamicQueryFieldPicker,
    };
})();

export default DynamicQuery; 